import { Extension, Node, mergeAttributes } from '@tiptap/core';

/**
 * TipTap block node for preserving generated trust/citation sections during edit/save.
 */
export const TrustSection = Node.create({
  name: 'trustSection',
  group: 'block',
  content: 'block+',
  defining: true,

  addAttributes() {
    return {
      templateGoal: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-template-goal'),
        renderHTML: (attributes) => (
          attributes.templateGoal ? { 'data-template-goal': attributes.templateGoal } : {}
        ),
      },
      confidence: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-confidence'),
        renderHTML: (attributes) => (
          attributes.confidence ? { 'data-confidence': attributes.confidence } : {}
        ),
      },
      sourceLineIds: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-source-line-ids'),
        renderHTML: (attributes) => (
          attributes.sourceLineIds ? { 'data-source-line-ids': attributes.sourceLineIds } : {}
        ),
      },
      citationComment: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-citation-comment'),
        renderHTML: (attributes) => (
          attributes.citationComment ? { 'data-citation-comment': attributes.citationComment } : {}
        ),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'section[data-trust-section="true"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'section',
      mergeAttributes(HTMLAttributes, { 'data-trust-section': 'true' }),
      0,
    ];
  },
});

/**
 * Preserve trust/citation attributes on paragraphs and headings, including
 * action-required blocks that are emitted as `<p data-trust-section="true">`.
 */
export const TrustMetadataAttributes = Extension.create({
  name: 'trustMetadataAttributes',

  addGlobalAttributes() {
    return [
      {
        types: ['paragraph', 'heading'],
        attributes: {
          trustSection: {
            default: null,
            parseHTML: (element) => element.getAttribute('data-trust-section'),
            renderHTML: (attributes) => (
              attributes.trustSection ? { 'data-trust-section': attributes.trustSection } : {}
            ),
          },
          templateGoal: {
            default: null,
            parseHTML: (element) => element.getAttribute('data-template-goal'),
            renderHTML: (attributes) => (
              attributes.templateGoal ? { 'data-template-goal': attributes.templateGoal } : {}
            ),
          },
          confidence: {
            default: null,
            parseHTML: (element) => element.getAttribute('data-confidence'),
            renderHTML: (attributes) => (
              attributes.confidence ? { 'data-confidence': attributes.confidence } : {}
            ),
          },
          sourceLineIds: {
            default: null,
            parseHTML: (element) => element.getAttribute('data-source-line-ids'),
            renderHTML: (attributes) => (
              attributes.sourceLineIds ? { 'data-source-line-ids': attributes.sourceLineIds } : {}
            ),
          },
          citationComment: {
            default: null,
            parseHTML: (element) => element.getAttribute('data-citation-comment'),
            renderHTML: (attributes) => (
              attributes.citationComment ? { 'data-citation-comment': attributes.citationComment } : {}
            ),
          },
        },
      },
    ];
  },
});

